import React from 'react'
import { Route, Switch } from 'react-router'

import { AuthPage } from '../pages/AuthPage'
import { LoginPage } from '../pages/LoginPage'
import { LogoutPage } from '../pages/LogoutPage'
import { NotFoundPage } from '../pages/NotFoundPage'
import { EmailExportRoute } from './EmailExportRoute'
import { MainRoute } from './MainRoute'
import { SecureRoute } from './SecureRoute'

export const Routing = () => (
  <Switch>
    <Route path="/" exact render={() => <RedirectToNew />} />
    <Route path="/register" render={() => <RedirectToNew register />} />
    <Route path="/login" component={LoginPage} />
    <Route path="/logout" component={LogoutPage} />
    <Route path="/auth" component={AuthPage} />
    <SecureRoute path="/emails" component={EmailExportRoute} />
    <SecureRoute path="/admin" component={MainRoute} />
    <Route component={NotFoundPage} />
  </Switch>
)

function RedirectToNew({ register = false }: { register?: boolean }) {
  let url = 'https://platebni-brany.cz'
  if (register) {
    url += '/register/gopay'
  }
  window.location.assign(url)
  return null
}
